// extracted by mini-css-extract-plugin
export default {"root":"Link-root-a403","minimal":"Link-minimal-d1f2","inline":"Link-inline-e0ae","withTooltip":"Link-withTooltip-d8c5","tooltip":"Link-tooltip-b622"};